import Vue from 'vue'
import SupportChat from '~/components/supportChat.vue'

// Mounts the SMS "text us" support widget once, globally (appended to <body>),
// so it appears on every page regardless of layout — the same 1:1 pattern the
// old tawk.to plugin used. The widget's events run through the global
// pls_app_track mixin, which applies to this standalone instance too.
export default function () {
  if (typeof window === 'undefined') return
  var mount = function () {
    if (document.getElementById('pls-support-chat-root')) return
    var el = document.createElement('div')
    el.id = 'pls-support-chat-root'
    document.body.appendChild(el)
    new Vue({ render: function (h) { return h(SupportChat) } }).$mount(el)
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount)
  } else {
    mount()
  }
}
